import { BaseApiService } from './baseApiService';
import type { ScribeRunState } from './scribeRunService';

export interface ScribeJob {
  job_id: number;
  session_id: number;
  recording_id: number;
  analysis_id: number | null;
  status: 'queued' | 'transcribing' | 'analyzing' | 'completed' | 'completed_with_errors' | 'failed';
  attempts: number;
  family_history_status: string;
  failure_reason: string;
  run: ScribeRunState | null;
}

export const jobIsActive = (job: ScribeJob) =>
  ['queued', 'transcribing', 'analyzing'].includes(job.status);

class ScribeJobService extends BaseApiService {
  async submit(recordingId: number, signal?: AbortSignal): Promise<ScribeJob> {
    const response = await this.fetchWithAuth<{ data: ScribeJob }>('/scribe-jobs/', {
      signal, method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ recording_id: recordingId }),
    });
    return response.data;
  }

  async list(sessionId?: number): Promise<ScribeJob[]> {
    const params = new URLSearchParams({ active: 'false' });
    if (sessionId) params.set('session_id', String(sessionId));
    return (await this.fetchWithAuth<{ data: ScribeJob[] }>(`/scribe-jobs/?${params}`)).data;
  }

  async retry(jobId: number): Promise<ScribeJob> {
    return (await this.fetchWithAuth<{ data: ScribeJob }>(`/scribe-jobs/${jobId}/retry/`, {
      method: 'POST',
    })).data;
  }
}

export const scribeJobService = new ScribeJobService();
